export const types = {
    /* UI */
    uiClearState: '[UI] clear state UI',
    uiConfig: "[UI] Ui Config",
    // loading
    uiStartLoading: '[UI] start loading',
    uiFinishLoading: '[UI] finish loading',

    // loading departamento
    uiStartLoadingDepartamento: '[UI] start loading loading departamento',
    uiFinishLoadingDepartamento: '[UI] finish loading loading departamento',

    // loading cargos
    uiStartLoadingCargo: '[UI] start loading loading cargo',
    uiFinishLoadingCargo: '[UI] finish loading loading cargo',

    // loading sucursales
    uiStartLoadingSucursal: '[UI] start loading loading Sucursal',
    uiFinishLoadingSucursal: '[UI] finish loading loading Sucursal',

    /* EMPLEADOS */
    empSetPuestos: "[EMPLEADO] set puestos",
    empSetDepartamentos: "[EMPLEADO] set empleados",
    empSetSucursal: "[EMPLEADO] set sucursal",
    empSetBusqueda: "[EMPLEADO] set busqueda"

}